import { TweenLite } from 'gsap/all'

export function completeFirstView() {
  const firstView = document.querySelector('.firstView')
  TweenLite.to(firstView, .5, {
    opacity: 0,
    display: 'none',
  })
  firstView.classList.add('complete')
}